import React from "react";
import "./whoweare.css";

const WhoWeAre = () => {
  return (
    <div id="whoweare" className="whoweare">
      <div className="whoweare-main d-flex flex-column container">
        <div className="company-features">
          <div className="company-feature">
            <div className="feature-icon-box">
              <div className="feature-title-box">
                <div className="img-div">
                  <img
                    className="whoweare-icon mob-icon"
                    src={require("../../assets/whoweare_pic004.png")}
                    alt="Point and Click Software icon"
                    draggable="false"
                  />
                </div>
                <h4 className="text-center fs-xl-para">
                  Point and Click Software
                </h4>
              </div>
              <p
                className="text-center fs-sm-para "
                style={{ fontFamily: "Nunito" }}
              >
                Automatically generates welding program based on operator input.
              </p>
            </div>
          </div>

          <div className="company-feature">
            <div className="feature-icon-box">
              <div className="feature-title-box">
                <div className="img-div">
                  <img
                    className="whoweare-icon mob-icon"
                    src={require("../../assets/whoweare_pic005.png")}
                    alt="AI-Vision for robots icon"
                    draggable="false"
                  />
                </div>
                <h4 className="text-center fs-xl-para">AI-Vision for robots</h4>
              </div>
              <p className="text-center fs-sm-para">
                Detects orientation and weld seams to automatically adapt the
                program for deviations.
              </p>
            </div>
          </div>

          <div className="company-feature">
            <div className="feature-icon-box">
              <div className="feature-title-box">
                <div className="img-div">
                  <img
                    className="whoweare-icon mob-icon"
                    src={require("../../assets/whoweare_pic006.png")}
                    alt="AI welder icon"
                    draggable="false"
                  />
                </div>
                <h4 className="text-center fs-xl-para">AI welder</h4>
              </div>
              <p className="text-center fs-sm-para">
                Fine tunes weld parameters automatically to optimise for
                quality.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoWeAre;
